module.exports = __webpack_public_path__ + "img/rental_car_blue.1094921.png";